import { IApplicationState } from 'shared/map-search/types/redux';

export const selectIsClustersRedesign = (state: IApplicationState) => Boolean(state.clustersType);
